export const sectionHeaderClassname = 'section-header font-size--16 font-color--grey--xx-dark--important';
export const commonClassname = 'font-color--greyXDark line-height--22';
export const vanityClassname = `vanity font-size--14 ${commonClassname}`;
export const spanClassname = `tos font-size--14 ${commonClassname}`;
export const pClassname = `font-size--16 ${commonClassname}`;
export const pClassnameWithMargin = `${pClassname} margin-top--large`;
